import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import autoBind from 'react-autobind';

const passwordStrength = {
    empty: { label: '', color: '#e0e0e0', value: 0 },
    veryWeak: { label: 'password_strength.score.very_weak', color: '#ef4444', value: 20 },
    weak: { label: 'password_strength.score.weak', color: '#f97316', value: 40 },
    fair: { label: 'password_strength.score.fair', color: '#eab308', value: 60 },
    good: { label: 'password_strength.score.good', color: '#84cc16', value: 80 },
    strong: { label: 'password_strength.score.strong', color: '#22c55e', value: 100 },
};

const scoreMap = {
    0: 'empty',
    1: 'veryWeak',
    2: 'weak',
    3: 'fair',
    4: 'good',
    5: 'strong',
};

const calculateStrength = password => {
    let score = 0;
    if (!password) return 0;

    if (password.length >= 8) score += 1;
    if (/[a-z]/.test(password)) score += 1;
    if (/[A-Z]/.test(password)) score += 1;
    if (/\d/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;

    return score;
};

class PasswordField extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            // Only use errorText for actual validation errors
            errorText: props.meta && props.meta.touched && props.meta.error ? props.meta.error : '',
            value: props.input ? props.input.value : props.value || '',
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            errorText: props.meta && props.meta.touched && props.meta.error ? props.meta.error : '',
        });
    }

    onChange(value, field) {
        this.setState({ value });

        if (field.input && field.input.onChange) {
            field.input.onChange(value);
        }
    }

    render() {
        const { t, ...field } = this.props;
        const { value, errorText } = this.state;

        // Calculate score using your original mapping logic
        const score = calculateStrength(value);

        const strengthKey = scoreMap[score] || 'empty';
        const { label, color, value: progressValue } = passwordStrength[strengthKey];

        return (
            <div style={{ width: '100%' }}>
                <TextField
                    {...(field.input || {})}
                    type="password"
                    fullWidth={true}
                    disabled={field.disabled}
                    hintText={field.hintText}
                    floatingLabelText={field.label}
                    errorText={errorText}
                    onChange={(event, val) => this.onChange(val, field)}
                />

                {value.length > 0 && (
                    <div style={{ width: '100%', marginTop: '2px' }}>
                        <div
                            style={{
                                height: '6px',
                                borderRadius: '4px',
                                backgroundColor: '#e5e7eb',
                                width: '100%',
                                overflow: 'hidden',
                            }}>
                            <div
                                style={{
                                    height: '100%',
                                    backgroundColor: color,
                                    width: `${progressValue}%`,
                                    transition: 'width 0.3s ease, background-color 0.3s ease',
                                }}
                            />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '4px' }}>
                            <span
                                style={{
                                    fontWeight: 500,
                                    color: color,
                                    fontSize: '1.25rem',
                                    minHeight: '1.125rem',
                                }}>
                                {value ? t(label) : ' '}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default PasswordField;
